import { whetherExistActivity } from 'api/api-php'
import * as types from './types'

/**
 * @author: xuhuibo
 * @function: 判断是否有硬件参与押金活动
 * @param  data {object} 请求参数
 * @return: {object}
 */
export const GetExistActivityData = ({ commit }) => {
  return new Promise((resolve, reject) => {
    whetherExistActivity().then(res => {
      let data = res.data
      commit(types.SET_EXIST_ACTIVITY, data)
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
